import DBUser from 'models/db/user.js';
const dbUser = new DBUser();

const state = {
  authority: [0]
}

const getters = {
}

const mutations = {
  authority(state, payload) {
    state.authority = payload.data
  }
}

const actions = {
  getAuthority({ commit }) {
    dbUser.getDBAuthority().then(res => {
      if (res.success) {
        let data = res.result
        commit('authority', {
          data
        })
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
